import _ from 'lodash'
import Decimal from 'decimal.js-light'

const DEFAULT_BOUNDING_BOX = { x: '-', y: '-', z: '-' }

export const UNITS_MM = 'mm'
export const UNITS_IN = 'in'
export const UNITS_INCHES = 'inches'

const MM_TO_INCHES = 25.4

function formatString({ x, y, z }, units) {
    return `${x} x ${y} x ${z} ${units}`
}

function convertBoundingBox(unsafeBoundingBox) {
    if (unsafeBoundingBox == null) {
        return null
    }

    const justXYZ = _.pick(unsafeBoundingBox, ['x', 'y', 'z'])
    const maybeNums = _.values(justXYZ)

    if (maybeNums.some(element => element === null || isNaN(element))) {
        return null
    }

    return _.mapValues(justXYZ, Decimal)
}

function convertToUnits(decimal, units) {
    if (units === UNITS_MM) {
        return decimal
    }

    return decimal.div(MM_TO_INCHES)
}

function formatDecimal(units) {
    return decimal => {
        return convertToUnits(decimal, units).toFixed(2)
    }
}
/*
  For formatting a bounding box string into something with units
  -- and if it's malformed at all, just return with empty values
*/
export default function getDimensionsDisplayWithUnits(
    unsafeBoundingBox,
    units,
) {
    const maybeDimensions = convertBoundingBox(unsafeBoundingBox)

    if (maybeDimensions != null) {
        return formatString(
            _.mapValues(maybeDimensions, formatDecimal(units)),
            units,
        )
    }

    return formatString(DEFAULT_BOUNDING_BOX, units)
}
